import React from "react";
import { FormattedMessage } from "react-intl";
import { InfoAlert } from "theme/components/molecules/Alert";
import useAddToCartError from "./useAddToCartError";

const AddToCartError = () => {
  const addToCartError = useAddToCartError();
  if (!addToCartError) {
    return null;
  }

  return (
    <InfoAlert>
      <FormattedMessage
        id="modules.ProductAddedPopIn.addToCartError"
        defaultMessage="However, the following products are no longer available: {products}."
        values={{
          products: addToCartError,
        }}
      />
    </InfoAlert>
  );
};

export default AddToCartError;
